<template>
    <span class="icon-wrapper" :style="{width: size+'px'}">
        <svg class="icon-logo" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="130 200 300 150" xml:space="preserve">
            <g class="icon-logo--texts" :fill="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary">
                <path d="M265 297.4l-1.7-4.5h-14.6l-1.7 4.6c-.7 1.8-1.2 3-1.7 3.6-.5.6-1.2.9-2.3.9-.9 0-1.7-.3-2.4-1s-1.1-1.4-1.1-2.3c0-.5.1-1 .2-1.5s.4-1.2.8-2.2l9.2-23.3c.3-.7.6-1.5.9-2.4.4-.9.8-1.7 1.2-2.3.4-.6 1-1.1 1.6-1.5.7-.4 1.5-.6 2.5-.6s1.9.2 2.5.6c.7.4 1.2.9 1.6 1.5.4.6.8 1.3 1.1 1.9.3.7.6 1.6 1.1 2.8l9.4 23.2c.7 1.8 1.1 3 1.1 3.8 0 .8-.3 1.6-1 2.3-.7.7-1.5 1-2.5 1-.6 0-1.1-.1-1.5-.3-.4-.2-.8-.5-1-.8-.3-.4-.6-.9-.9-1.6-.3-.8-.5-1.4-.8-1.9zm-14.4-10h10.7l-5.4-14.8-5.3 14.8z" />
                <path d="M287.9 286.1h-2.5v11.5c0 1.5-.3 2.6-1 3.4-.7.7-1.5 1.1-2.6 1.1-1.2 0-2.1-.4-2.7-1.1-.6-.8-1-1.9-1-3.3V270c0-1.6.4-2.7 1.1-3.4.7-.7 1.8-1.1 3.4-1.1h11.8c1.6 0 3 .1 4.2.2 1.2.1 2.2.4 3.1.8 1.1.5 2.1 1.2 3 2 .9.9 1.5 1.9 2 3.1.4 1.2.7 2.4.7 3.7 0 2.7-.8 4.8-2.3 6.4-1.5 1.6-3.8 2.7-6.9 3.4 1.3.7 2.5 1.7 3.7 3 1.2 1.3 2.2 2.8 3.1 4.3.9 1.5 1.6 2.9 2.2 4.1.5 1.2.8 2.1.8 2.5 0 .5-.2.9-.5 1.4-.3.5-.7.8-1.2 1.1-.5.3-1.1.4-1.8.4-.8 0-1.5-.2-2.1-.6-.6-.4-1-.9-1.4-1.5-.4-.6-.9-1.5-1.6-2.6l-2.9-4.8c-1-1.8-2-3.1-2.8-4.1-.8-.9-1.7-1.6-2.5-1.9-.9-.2-2-.3-3.3-.3zm4.2-15.1h-6.7v9.9h6.5c1.7 0 3.2-.2 4.4-.5 1.2-.3 2.1-.8 2.7-1.5.6-.7.9-1.7.9-3 0-1-.3-1.9-.8-2.6-.5-.8-1.2-1.3-2.1-1.7-.8-.4-2.4-.6-4.9-.6z" />
                <path d="M344.1 290.1c0 1.1-.3 2.4-.8 3.7-.6 1.3-1.4 2.6-2.7 3.9-1.2 1.3-2.8 2.3-4.6 3.1-1.9.8-4.1 1.2-6.6 1.2-1.9 0-3.6-.2-5.2-.5-1.6-.4-3-.9-4.2-1.7-1.3-.8-2.4-1.8-3.5-3-.9-1.1-1.8-2.4-2.4-3.8-.7-1.4-1.2-2.9-1.5-4.5s-.5-3.3-.5-5c0-2.9.4-5.5 1.3-7.8.8-2.3 2-4.2 3.6-5.9 1.6-1.6 3.4-2.9 5.5-3.7 2.1-.8 4.4-1.3 6.7-1.3 2.9 0 5.5.6 7.8 1.7 2.3 1.2 4 2.6 5.2 4.3 1.2 1.7 1.8 3.3 1.8 4.8 0 .8-.3 1.6-.9 2.2-.6.6-1.3 1-2.1 1-.9 0-1.6-.2-2.1-.7-.5-.4-1-1.2-1.6-2.3-.9-1.8-2.1-3.1-3.3-4-1.3-.9-2.9-1.3-4.7-1.3-3 0-5.4 1.1-7.1 3.4-1.8 2.3-2.7 5.5-2.7 9.7 0 2.8.4 5.1 1.2 7 .8 1.9 1.9 3.2 3.3 4.2 1.4.9 3.1 1.4 5 1.4 2.1 0 3.9-.5 5.3-1.6 1.4-1 2.5-2.6 3.3-4.6.3-.9.7-1.7 1.2-2.3.5-.6 1.2-.9 2.2-.9.9 0 1.6.3 2.2.9.6.7.9 1.5.9 2.4z" />
                <path d="M357.8 269.3v26.1h14.7c1.2 0 2.1.3 2.7.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.1-.6.5-1.5.8-2.7.8H355c-1.6 0-2.7-.4-3.4-1.1-.7-.7-1-1.8-1-3.4v-27.6c0-1.5.3-2.6 1-3.3.7-.7 1.5-1.1 2.6-1.1s2 .4 2.7 1.1c.6.7.9 1.8.9 3.3z" />
                <path d="M381.3 297.6v-28.3c0-1.5.3-2.6 1-3.3.7-.7 1.5-1.1 2.6-1.1s2 .4 2.7 1.1c.7.7 1 1.8 1 3.3v28.3c0 1.5-.3 2.6-1 3.3-.7.7-1.6 1.1-2.7 1.1-1 0-1.9-.4-2.6-1.1-.7-.7-1-1.8-1-3.3z" />
                <path d="M418.1 271.1h-14.3v9.2h12c1.1 0 1.9.2 2.5.7.5.5.8 1.2.8 2s-.3 1.5-.8 2c-.6.5-1.4.7-2.5.7h-12v11.8c0 1.5-.3 2.6-1 3.3-.7.7-1.5 1.1-2.6 1.1s-2-.4-2.6-1.1c-.7-.7-1-1.8-1-3.3V270c0-1 .2-1.9.5-2.6.3-.7.8-1.1 1.5-1.4.7-.3 1.5-.5 2.5-.5h17.1c1.2 0 2 .3 2.6.8.6.5.8 1.2.8 2s-.3 1.5-.8 2c-.7.6-1.5.8-2.7.8z" />
            </g>
            <g class="icon-logo__symbol" :fill="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary" :stroke="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary">
                <path d="M202.5 301.6c-2.1 0-3.8-1.7-3.8-3.8v-12.2L187.3 274l-11.4 11.7v12.2c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8v-13.2c0-1.3.5-2.6 1.5-3.6l14-14.2c1-1 2.2-1.5 3.6-1.5s2.6.5 3.6 1.5l14 14.2c.9 1 1.5 2.2 1.5 3.6v13.2c-.2 2-1.9 3.7-4 3.7z" />
                <path d="M209.4 325.4h-44.2c-10.9 0-19.8-8.9-19.8-19.8v-44.2c0-10.9 8.9-19.8 19.8-19.8h44.2c10.9 0 19.8 8.9 19.8 19.8v44.2c0 10.9-8.9 19.8-19.8 19.8zm-44.2-76.3c-6.8 0-12.3 5.5-12.3 12.3v44.2c0 6.8 5.5 12.3 12.3 12.3h44.2c6.8 0 12.3-5.5 12.3-12.3v-44.2c0-6.8-5.5-12.3-12.3-12.3h-44.2z" />
            </g>
        </svg>
    </span>
</template>
<script>
import ScrollMagic from "scrollmagic"
import { gsap } from "gsap"

export default {
    props: ['size'],

    data: () => ({
        barHeight: 64,
        scrollController: null,
        tween: null,
        scene: null
    }),

    mounted() {
        this.$nextTick(() => {
            // Initialize scroll controller
            if (this.isDesktop) {
                this.createScrollController()
            }

        })
    },

    methods: {
        /* 
         * Adding scroll scenes
         */
        createScrollController() {
            //Creating controller and Adding scenes
            this.scrollController = new ScrollMagic.Controller()
            this.iconScene()
        },

        iconScene() {
            //Creating scene
            this.tween = gsap.to(this.$el.querySelectorAll('.icon-logo--texts>path'), {
                duration: 0.2,
                y: -10,
                stagger: 0.05,
                autoAlpha: 0
            })

            this.scene = new ScrollMagic.Scene({
                    triggerHook: "onLeave",
                    offset: this.$store.state.common.scrollOffset
                })
                .setTween(this.tween)
                .addTo(this.scrollController)
        }
    }
}
</script>